export default {
  abandonProduct: 'Abandonner le produit',
  abandonProductTips:
    'Rappel amical : Lorsque vous confirmez [Abandonner le produit], nous détruirons votre produit et il ne pourra pas être récupéré. Le produit ne sera pas retourné au vendeur pour un remboursement. Veuillez procéder avec prudence.',
  finePhotos: 'Photographie détaillée',
  ordinaryPhotos: 'Image ordinaire',
  expireText: "Le colis est sur le point d'expirer",
  more: 'Plus',
  timeExpand: 'Durée prolongée',
  guaranteeService: 'Service de garantie',
  noNeed: 'Pas besoin',
  'i18n-0000002':
    'Votre article a dépassé la période de stockage. Nous le conserverons pendant 28 jours supplémentaires. Après cette période, il sera considéré comme abandonné et éliminé en conséquence.',
  'i18n-0000003':
    'Si vous devez prolonger la période de stockage, veuillez acheter le service à valeur ajoutée pour le stockage prolongé dans les 28 jours.',
  'i18n-0000004': "Délai d'expiration du stockage",
  'i18n-0000016': 'Le stockage du produit a expiré',
  'i18n-0000019':
    "Prolongation de stockage non payée. L'article est considéré comme volontairement abandonné.",
  'i18n-0000023': 'Terminé',
  refundTip: 'Après confirmation, les frais de stockage seront remboursés sur votre compte.',
  storageEnum: {
    1: 'Entrepôt 1, Chine',
    2: 'Entrepôt 2, Chine',
  },
  'i18n-00001': `J'accepte les modifications apportées à mes informations de déclaration fournies par acbuy afin de me conformer aux exigences douanières locales et d'améliorer les tarifs de dédouanement. En l'absence d'assurance, je serai seul responsable des obligations et conséquences du dédouanement.`,
  'i18n-00002': `Je n'accepte pas ces modifications. Veuillez déclarer les informations telles quelles. Je serai seul responsable des obligations et conséquences du dédouanement.`,
  'i18n-00003': 'Accepter les modifications',
  'i18n-00004': 'Refuser les modifications',
  'i18n-00005': 'Modification des informations de déclaration',
  'i18n-00006':
    'Basé sur le poids réel ou volumétrique, le plus élevé des deux. Toute différence sera remboursée ou facturée dans les 72 heures suivant l’emballage.',
  'i18n-00008':
    'Chaque message de déclaration doit contenir moins de {length} caractères. Veuillez ajuster et soumettre à nouveau',
  'i18n-00009':
    '{AI} a encore des services à valeur ajoutée non payés. Pour les conserver, veuillez effectuer le paiement et attendre la fin du service avant de soumettre le colis. Si vous choisissez de soumettre le colis maintenant, le système annulera automatiquement les services à valeur ajoutée correspondants qui restent impayés.',
}
